module.exports = __webpack_public_path__ + "static/visual_8_2_eg-65e24bede1dcac41d1796cfb72aae4ce.png";